
    import axios from 'axios';
    import {processDoLoopInfo, processDataRow} from './utils';
    const GB_API_BASE_URL = process.env.REACT_APP_GB_API_BASE_URL;
    
    export const fetchToken = () => {
       return  axios.get(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/MicroBiz/GetApigeeToken`);
    }
 
 
    export const getSelectedBundleInfo = (apiToken, doLoopResponse) => {
        if(doLoopResponse?.DataInfo) {
            let internetPlanData = doLoopResponse?.DataInfo?.Plans[0];
            const infoParams = {
                bundleID: internetPlanData?.PackageId,
                tvID: 0,
                nLines: 1,
                contract: internetPlanData?.Contract,
                hcid: internetPlanData?.ProductId ? internetPlanData?.ProductId : '',
                ptype: internetPlanData?.ServiceType ? internetPlanData?.ServiceType : '',
                bRc: internetPlanData?.Price,
                upselSelected: false
              };
    
            return axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdSelection/getSelectedBundleInfo`,
            infoParams,
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
        }
        else if(doLoopResponse?.PhoneInfo) {
            const bundleID = doLoopResponse?.PhoneInfo[0]?.BID;
            const bRc = doLoopResponse?.PhoneInfo[0]?.BundleRC;
            const preferredvoiceFormData = {
                BID: bundleID,
                RC: bRc,
                nlines:1
            };
            return axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdSelection/GetPreferedVoice`,
            preferredvoiceFormData,
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
        } 
    }
 
    export const postDoLoop =  (apiToken, dataRow) => { 
        const requestBody = processDoLoopInfo(dataRow);
        return axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/Qualify/DoLoopQualification?BDVCETC=N&cetctest=N`,
        requestBody,
        {
            headers: { 
            'Authorization': apiToken,
            'Content-Type': 'application/json'
            }
        });
    }

    export const postCheckAvailability = (apiToken, dataRow) => {
        const requestBody = processDoLoopInfo(dataRow);
        axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/Qualify/CheckAvailability`,
        requestBody,
        {
            headers: { 
            'Authorization': apiToken,
            'Content-Type': 'application/json'
            }
        });
    }

    export const postUpdateCartInternet = (apiToken) => {
        const requestBody = {
            "ProductType":"FIOSDATA",
            "fiOSDataModelPost":
                {
                    "DataPlanSelection": {
                        "NewID":"25568262"
                    },
                    "DataSelection": {
                        "NewID":"23851082"
                    }
                }
            };
        return axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdConfig/UpdateCart`,
        requestBody,
        {
            headers: { 
            'Authorization': apiToken,
            'Content-Type': 'application/json'
            }
        });
    }

    export const  postUpdateCartRouter = (apiToken) => {
        const requestBody = {"ProductType":"HSIDATA","hsiDataModelPost":{"RouterSelection":{"NewID":"25574692","OldID":""}}};
        return axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdConfig/UpdateCart`,
        requestBody,
        {
            headers: { 
            'Authorization': apiToken,
            'Content-Type': 'application/json'
            }
        });
    }

    export const postSaveCart = (apiToken) => {
        return axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/SaveOrder/SaveMyOrder`,
        {},
        {
            headers: { 
            'Authorization': apiToken,
            'Content-Type': 'application/json'
            }
        });
    }
    export const doSaveCart = (apiToken, targetTestEmail) => {
        return   axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/SaveOrder/DoSaveOrder`,
            {
                "Comments":"",
                "Disclaimer":"N",
                "EMail":targetTestEmail,
                "RatingSelected":"",
                "SkipReminderMail":"N"
            },
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
    }
    
    export const postUpdateCartSABDV = (apiToken, payload) => {
        return   axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdSelection/GetSABDV`,
           payload,
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
    }

    export const postUpdatePhoneEquipment = (apiToken, tnData) => {
        return   axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdConfig/UpdateCart`,
            {
                "ProductType":"BDV",
                "BdvModelPost": {
                    "EquipMapping": [
                        {
                            "EqpID":"25441894",
                            "AddlHandset":"",
                            "TNs": tnData
                        }
                    ]
                }
            },
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
    }

    export const getCustomizeProducts = (apiToken, targetTestEmail) => {
        return   axios.get(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdSelection/GetCustomizeProductsNew`,
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
    }
    export const getPreferredVoiceData = (apiToken, payload) => {
        return   axios.post(`${GB_API_BASE_URL}/foryoursmallbiz/smb/api/PrdSelection/GetPreferedVoice`,
        payload,
            {
                headers: { 
                'Authorization': apiToken,
                'Content-Type': 'application/json'
                }
            });
    }

    